import * as S from './styles';

export const Dots = ({ number, active, width, height }) => (
  <S.Dots>
    {[...Array(number)].map((item, i) => (
      <S.Dot key={i} active={i === active} width={width} height={height} />
    ))}
  </S.Dots>
);
